import { Component, forwardRef, Input, OnInit } from '@angular/core';
import {
  ControlContainer,
  ControlValueAccessor,
  NG_VALUE_ACCESSOR,
} from '@angular/forms';

@Component({
    selector: 'pr-input-percent',
    templateUrl: './pr-input-percent.component.html',
    styleUrls: ['./pr-input-percent.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => PrInputPercentComponent),
            multi: true,
        },
    ],
    standalone: false
})
export class PrInputPercentComponent implements OnInit, ControlValueAccessor {
  percent: number;
  @Input() formControlName: string;

  @Input() isProportion: boolean = true; // true si on veut que la valeur soit entre 0 et 1
  @Input() allowDecimal: boolean = true; // Pour autoriser les valeurs décimales
  @Input() derrors: boolean = false;
  @Input() required: boolean = false;
  @Input() label: string;
  @Input() suffix: string;
  @Input() isDefault = true;
  @Input() readonly = false;
  @Input() minValue: number = 0; // New input for minimum value
  @Input() maxValue: number = Infinity; // New input for minimum value
  percentValue: number;

  private onChange: (value: any) => void;
  private onTouched: () => void;
  constructor(private controlContainer: ControlContainer) {}

  get control() {
    return this.controlContainer.control.get(this.formControlName);
  }

  ngOnInit() {
    if (this.control)
      this.percentValue =
        (this.isProportion ? this.control.value * 100 : this.control.value) ||
        null;
  }
  onPercentChange(value: number) {
    if (!this.allowDecimal) {
      // Si allowDecimal est false, arrondir à l'entier le plus proche
      value = Math.round(value);
    }
    this.percentValue = value;
    this.onChange(this.isProportion ? value / 100 : value);
    this.onTouched();
  }

  writeValue(value: any) {
    this.percentValue = value
      ? this.isProportion
        ? value * 100
        : value
      : null;
  }

  registerOnChange(fn: (value: any) => void) {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void) {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean) {
    // Implement if needed
  }
  labelFinishWithSpace(): boolean {
    return this.label && this.label.slice(-1) == ' ';
  }

  onKeyDown(event: KeyboardEvent) {
    if (!this.allowDecimal) {
      // Si allowDecimal est false, empêcher la saisie des caractères non numériques, des virgules et des points
      if (['.', ',', '-', '+'].includes(event.key)) {
        event.preventDefault();
      }
    }
  }
}
